import React from "react"
import {
  Col,
  Label,
  Row
} from "reactstrap"

const otherDetails = ({ partnerDetails }) => {
  return (
    <React.Fragment>
       <h4 className="card-title mb-2">Dealer Partners</h4>
      {partnerDetails?.map((elem,index,array) => {
        return (
          <>
        <Row className="mb-4" key={elem.id}>
          <Col md={3}>
            <Label htmlFor="horizontal-email-Input" className="col-sm-6 label-styling ">
              Dealer Code
            </Label>
            <br />
            <span>{elem.dealerCode || "-"}</span>
          </Col>
          <Col md={3}>
            <Label htmlFor="horizontal-email-Input" className="col-sm-6 label-styling ">
              Partner Type Code
            </Label>
            <br />
            <span>{elem.partnerTypeCode || "-"}</span>
          </Col>
          <Col md={3}>
            <Label htmlFor="horizontal-email-Input" className="col-sm-12 label-styling ">
              Partner Type Code Description
            </Label>
            <br />
            <span>{elem.partnerTypeCodeDescription || "-"}</span>
          </Col>
          <Col md={3}>
            <Label htmlFor="horizontal-email-Input" className="col-sm-6 label-styling ">
              Partner Code
            </Label>
            <br />
            <span>{elem.partnerCode || "-"}</span>
          </Col>
        </Row>
        {index !== array.length - 1 &&
          <div className="mb-4" style={{borderTop:"1px solid #d3d3d3"}}></div> }
          </>)
      })}
    </React.Fragment>
  )
}

export default otherDetails
